import {Component, Input, OnInit} from '@angular/core';
import {UntypedFormGroup, ReactiveFormsModule} from '@angular/forms';
import {NgxMaskModule} from 'ngx-mask';
import {RequiredComponent} from '../required/required.component';
import {ValidationErrorsComponent as ValidationErrorsComponent_1} from '../validation-errors/validation-errors.component';
import {TranslateModule} from '@ngx-translate/core';

@Component({
    selector: 'app-phone-form-row',
    templateUrl: './phone-form-row.component.html',
    styleUrls: ['./phone-form-row.component.scss'],
    imports: [ReactiveFormsModule, NgxMaskModule, RequiredComponent, ValidationErrorsComponent_1, TranslateModule]
})
export class PhoneFormRowComponent implements OnInit {

  @Input() formGroup: UntypedFormGroup;
  @Input() phoneFormControlName: string;
  @Input() extensionFormControlName: string;
  @Input() readOnly: boolean = false;
  @Input() enablePhoneMask: boolean = true;

  @Input() phoneNumberCssClass: string;
  @Input() extensionCssClass: string;

  /**
   * This gets passed to the nested validation-error components.
   *
   * @see {@link ValidationErrorsComponent.displayErrors}
   */
  @Input() displayErrors: boolean = false;

  phoneMask: string;

  constructor() { }

  ngOnInit() {
    this.phoneMask = this.enablePhoneMask ? '(000) 000-0000' : '9999999999999999999999999999999999';
  }

}
